import { IdName } from '../../../shared/models';

export class EmployeeScore {
    employee: IdName;
    sales: number;
    averageSalaryPerHour: number;
    commission: number;
    hours: number;
    locationName: string;
    salary: number;

    constructor(data: EmployeeScore) {
        Object.assign(this, data);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/shared/models/employee-score.ts